let activeOptions = {};

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function getStyleProperty(element, property) {
  return window.getComputedStyle(element).getPropertyValue(property);
}

/*
 * Shopify Common JS
 *
 */

if (typeof window.Shopify === "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || "post";
  const params = options.parameters || {};

  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (const key in params) {
    const hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options.hideElement || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry() {
    const value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince() {
    const value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler(e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    const raw = opt.getAttribute("data-provinces");
    const provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (let i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions(selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class QuantityCounter extends HTMLElement {
  constructor() {
    super();
    this.changeEvent = new Event("change", { bubbles: true });
  }

  connectedCallback() {
    this.counterEl = this.querySelector(".js-counter-quantity");
    this.increaseBtn = this.querySelector(".js-counter-increase");
    this.decreaseBtn = this.querySelector(".js-counter-decrease");

    this.min = parseInt(this.counterEl.min) || 1;
    this.max = parseInt(this.counterEl.max) || 999;

    this.increaseBtn.addEventListener("click", this.onIncrease.bind(this));
    this.decreaseBtn.addEventListener("click", this.onDecrease.bind(this));
  }

  onIncrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (currentValue < this.max) {
      this.updateValue(currentValue + 1);
    }
  }

  onDecrease() {
    const currentValue = parseInt(this.counterEl.value);
    if (this.dataset.cart) this.min = 0;
    if (currentValue > this.min) {
      this.updateValue(currentValue - 1);
    }
  }

  updateValue(value) {
    this.counterEl.value = value;

    this.counterEl.dispatchEvent(this.changeEvent);
  }
}

// Define the custom element
window.customElements.define("quantity-counter", QuantityCounter);

// without under functions main-password doesn't work

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

function toggleTabindex(elements) {
  elements.forEach((el) => {
    const tabindex = el.getAttribute("tabindex");
    el.setAttribute("tabindex", tabindex === "0" ? "-1" : "0");
  });
}

function setTabindex(elements, tabindex) {
  elements.forEach((el) => {
    el.setAttribute("tabindex", tabindex);
  });
}

// Helper function to add multiple event listeners with the same handler
function addEventListeners(element, events, handler) {
  events.forEach((event) => element.addEventListener(event, handler));
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);
document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

class ProductCardReviews extends HTMLElement {
  constructor() {
      super()
  }
  connectedCallback() {
      let ratingCount = Math.round(this.querySelector(".jdgm-prev-badge__stars").getAttribute("data-score") * 10) / 10;
      let totalReviews = this.querySelector(".jdgm-prev-badge").getAttribute("data-number-of-reviews")
      if (ratingCount && ratingCount ){
        this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 13 13" fill="none"><path d="M6.47577 0.809082L7.82285 4.95498H12.1821L8.6554 7.51729L10.0025 11.6632L6.47577 9.10088L2.94906 11.6632L4.29614 7.51729L0.76943 4.95498H5.12868L6.47577 0.809082Z" fill="#FFBF01" stroke="#B40001" stroke-width="0.5"/></svg> ${ratingCount} <span>(${totalReviews})</span>` ;
        this.style="display:flex";
      }
      else {
        this.innerHTML = "";
      }
  }
}
customElements.define("product-card-reviews", ProductCardReviews);

class ShareButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", this.shareProduct.bind(this));
  }

  shareProduct() {
    const title = this.dataset.title;
    const url = this.dataset.url;

    if (navigator.share) {
      navigator.share({
        title: title,
        text: "Check out this product",
        url: url
      }).catch((error) => console.log("Error sharing:", error));
    } else {
      window.open(
        `https://wa.me/?text=${encodeURIComponent(url)}`,
        "_blank"
      );
    }
  }
}

customElements.define("share-button", ShareButton);
class SwiperProgressbar extends HTMLElement {
  connectedCallback() {
    this.handleResize = this.handleResize.bind(this);
    this.waitForSwiper();
  }

  waitForSwiper() {
    if (typeof Swiper !== "undefined") {
      this.initLogic();
      window.addEventListener("resize", this.handleResize);
    } else {
      setTimeout(() => this.waitForSwiper(), 50);
    }
  }

  initLogic() {
    const disableMobile = this.dataset.disableMobile === "true";
    const breakpoint = Number(this.dataset.disableBreakpoint ?? 768);

    if (disableMobile && window.innerWidth < breakpoint) {
      this.destroySwiper();
    } else {
      if (!this.swiper) {
        this.initSwiper();
      }
    }
  }

  handleResize() {
    this.initLogic();
  }

  initSwiper() {
    const slider = this.querySelector(".swiper");
    const progressFill = this.querySelector(".swiper-progress-fill");

    if (!slider || !progressFill) return;

    const config = {
      slidesPerView: Number(this.dataset.slidesMobile ?? 1),
      spaceBetween: Number(this.dataset.spaceMobile ?? 8),
      speed: Number(this.dataset.speed ?? 300),

      loop: this.dataset.loop === "true",
      freeMode: this.dataset.freeMode === "true",
      centeredSlides: this.dataset.centered === "true",
      grabCursor: this.dataset.grabCursor !== "false",

      breakpoints: {
        749: {
          slidesPerView: Number(this.dataset.slidesDesktop ?? 3),
          spaceBetween: Number(this.dataset.spaceDesktop ?? 16)
        }
      },

      // 🔹 Progress events
      on: {
        init: () => this.updateProgress(),
        slideChange: () => this.updateProgress(),
        setTranslate: () => this.updateProgress()
      }
    };

    // 🔹 Navigation
    if (this.dataset.navigation !== "false") {
      const next = this.querySelector(".swiper-button-next");
      const prev = this.querySelector(".swiper-button-prev");

      if (next && prev) {
        config.navigation = { nextEl: next, prevEl: prev };
      }
    }

    // 🔹 Pagination
    if (this.dataset.pagination === "true") {
      const el = this.querySelector(".swiper-pagination");
      if (el) {
        config.pagination = {
          el,
          clickable: true,
          type: this.dataset.paginationType || "bullets"
        };
      }
    }

    // 🔹 Scrollbar
    if (this.dataset.scrollbar === "true") {
      const el = this.querySelector(".swiper-scrollbar");
      if (el) {
        config.scrollbar = {
          el,
          draggable: true
        };
      }
    }

    // 🔹 Autoplay
    if (this.dataset.autoplay === "true") {
      config.autoplay = {
        delay: Number(this.dataset.autoplayDelay ?? 3000),
        disableOnInteraction: false
      };
    }

    this.swiper = new Swiper(slider, config);

    this.classList.add("swiper-initialized-custom");
  }

  updateProgress() {
    if (!this.swiper) return;

    const progress = this.swiper.progress; // 0 → 1
    const percent = progress * 100;

    const fill = this.querySelector(".swiper-progress-fill");
    if (fill) {
      fill.style.width = percent + "%";
    }
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;

      this.classList.remove("swiper-initialized-custom");
    }
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    this.destroySwiper();
  }
}

customElements.define("swiper-progressbar", SwiperProgressbar);

class SwiperComponent extends HTMLElement {
  connectedCallback() {
    this.handleResize = this.handleResize.bind(this);
    this.waitForSwiper();
  }

  waitForSwiper() {
    if (typeof Swiper !== "undefined") {
      this.initLogic();
      window.addEventListener("resize", this.handleResize);
    } else {
      setTimeout(() => this.waitForSwiper(), 50);
    }
  }

  initLogic() {
    const disableMobile = this.dataset.disableMobile === "true";
    const breakpoint = parseInt(this.dataset.disableBreakpoint) || 768;

    if (disableMobile && window.innerWidth < 749) {
      this.destroySwiper();
    } else {
      if (!this.swiper) {
        this.initSwiper();
      }
    }
  }

  handleResize() {
    this.initLogic();
  }

  initSwiper() {
    const slider = this.querySelector(".swiper");
    if (!slider) return;

    const config = {
      slidesPerView: Number(this.dataset.slidesMobile ?? 1),
      spaceBetween: Number(this.dataset.spaceMobile ?? 8),
      speed: Number(this.dataset.speed ?? 300),

      loop: this.dataset.loop === "true",
      freeMode: this.dataset.freeMode === "true",
      centeredSlides: this.dataset.centered === "true",
      grabCursor: this.dataset.grabCursor !== "false",

      breakpoints: {
        749: {
          slidesPerView: Number(this.dataset.slidesDesktop ?? 3),
          spaceBetween: Number(this.dataset.spaceDesktop ?? 16)
        }
      }
    };

    // Navigation
    if (this.dataset.navigation !== "false") {
      const next = this.querySelector(".swiper-button-next");
      const prev = this.querySelector(".swiper-button-prev");

      if (next && prev) {
        config.navigation = { nextEl: next, prevEl: prev };
      }
    }

    // Pagination
    if (this.dataset.pagination === "true") {
      const el = this.querySelector(".swiper-pagination");
      if (el) {
        config.pagination = {
          el,
          clickable: true,
          type: this.dataset.paginationType || "bullets"
        };
      }
    }

    // Scrollbar
    if (this.dataset.scrollbar === "true") {
      const el = this.querySelector(".swiper-scrollbar");
      if (el) {
        config.scrollbar = {
          el,
          draggable: true
        };
      }
    }

    // Autoplay
    if (this.dataset.autoplay === "true") {
      config.autoplay = {
        delay: parseInt(this.dataset.autoplayDelay) || 3000,
        disableOnInteraction: false
      };
    }

    this.swiper = new Swiper(slider, config);

    // Optional: add class when active
    this.classList.add("swiper-initialized-custom");
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;

      // Optional: cleanup class
      this.classList.remove("swiper-initialized-custom");
    }
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    this.destroySwiper();
  }
}

customElements.define("swiper-component", SwiperComponent);

class CollectionTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let tabs = this.querySelectorAll(".collection-tab__tab");

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        let index = tab.getAttribute("data-index");

        let collection = this.querySelector(
          `.collection-tab__index-${index}`
        );

        this.querySelector(".collection-tab__collection.active")
          ?.classList.remove("active");

        collection.classList.add("active");

        this.querySelector(".collection-tab__tab.active")
          ?.classList.remove("active");

        tab.classList.add("active");

        tab.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest"
        });

        // IMPORTANT FIX
        const swiperComponent =
          collection.querySelector("swiper-progressbar");

        if (swiperComponent?.swiper) {
          swiperComponent.swiper.update();

          swiperComponent.swiper.slideTo(0, 0);

          swiperComponent.swiper.updateSize();

          swiperComponent.swiper.updateSlides();

          swiperComponent.swiper.updateProgress();

          swiperComponent.swiper.updateSlidesClasses();
        }
      });
    });
  }
}

customElements.define("collection-tabs", CollectionTabs);